<!-- eslint-disable -->
<template lang="pug">
    .school-preview
        .row.item-preview(
            @click="$emit('open', record.id)"
        )
            .col-xs-10.item-preview__column.item-preview__column_hide-name
                .school-preview__item
                    .school-preview__avatar
                        svg-icon.school-preview__icon(name="university", size="x-large")
                    router-link.preview__text.preview__text_large.school-preview__link.school-preview__link_large(:to="{name: 'school:profile', params: {id: record.id}}")
                        | {{ record.name }}
            .col-xs-2.col-sm-1.last-sm.end-xs.item-preview__column
                dropdown(:icon="false" without-move)
                    template(slot="link")
                        svg-icon.school-preview__icon.school-preview__icon_blue(name="select", :size="selectorSize")
                    ul.dropdown__links
                        li.dropdown__link(v-if="user && (user.isSuperadmin || user.isManagerOrSupport)")
                            router-link.school-preview__link(
                                :to="{name: 'billing:edit', params: {id: record.id}}"
                            )
                                | {{ $i18n.t('list.list_billing_settings') }}
                        li.dropdown-link(
                            v-else
                        )
                            router-link.school-preview__link(
                                :to="{name: 'school:profile', params: {id: record.id}}"
                            )
                                | {{ $i18n.t('list.list_billing_changeBalance') }}
            .col-xs-12.col-sm-11.item-preview__column
                .school-preview__name.hidden-xs
                    router-link.school-preview__link.school-preview__link_large(
                        :to="{name: 'school:profile', params: {id: record.id}}"
                    )
                        .school-preview__avatar
                            svg-icon.school-preview__icon(name="university", size="x-large")
                        .preview__text.preview__text_large
                            | {{ record.name }}
                .row.school-preview__info
                    .col-md-6.info__column
                        .school-preview__items.school-preview__items_columned
                            .school-preview__item
                                template(v-if="record.account.status")
                                    svg-icon.school-preview__icon(name="check")
                                    .preview__text {{ $i18n.t('fields.fields_statusActive') }}
                                template(v-else)
                                    svg-icon.school-preview__icon.school-preview__icon_orange(name="close")
                                    .preview__text {{ $i18n.t('fields.fields_statusBlocked') }}
                    .col-md-6.info__column
                        .school-preview__item
                            svg-icon.school-preview__icon(name="money" size="x-large")
                            div
                                .preview__text.preview__text_bold
                                    | {{ $i18n.t('list.list_billing_balance') }}
                                .preview__text
                                    | {{ record.account.balance && amountString(record.account.balance, true) }}
        transition-expand(v-show="record.id === openSchoolId")
            .indent-item.indent-item--billing
                .billing-table-wrapper
                    table.billing-table
                        thead
                            tr
                                th
                                    | {{ $i18n.t('fields.fields_date') }}
                                th
                                    | {{ $i18n.t('fields.fields_time') }}
                                th
                                    | {{ $i18n.t('fields.fields_user') }}
                                th
                                    | {{ $i18n.t('fields.fields_action') }}
                                th
                                    | {{ $i18n.t('fields.fields_object') }}
                                th
                                    | {{ $i18n.t('fields.fields_userName') }}
                                th
                                    | {{ $i18n.t('fields.fields_comment') }}
                                th
                                    | {{ $i18n.tc('fields.fields_school', 0) }}
                                th
                                    | {{ $i18n.t('elements.elements_datePicker_currentTariff') }}
                                th
                                    | {{ $i18n.t('profiles.profiles_school_sum') }}
                                th
                                    | {{ $i18n.t('billing.billing_settings_balance') }}
                                th
                                    | {{ $i18n.t('fields.fields_studentSlots') }}
                                th
                                    | {{ $i18n.t('fields.fields_teacherSlots') }}
                        tbody
                            tr(
                                v-for="(row, index) in billingRows"
                                :key="'billingRow-' + index"
                                v-if="!row.isSeparator"
                            )
                                td {{ row.date }}
                                td {{ row.time }}
                                td {{ row.user }}
                                td {{ row.event }}
                                td {{ row.subjectType }}
                                td {{ row.name }}
                                td {{ row.comment }}
                                td {{ row.school }}
                                td
                                    span(v-if="row.tariff")
                                        | {{ $i18n.t('billing.billing_tariff_' + row.tariff) }}
                                    span(v-else) -
                                td {{ row.amount }}
                                td {{ row.balance }}
                                td {{ row.studentSlots }}
                                td {{ row.teacherSlots }}
        account-balance-modal(
            v-if="showBalanceModal && user.type === 'admin'"
            @close="showBalanceModal = false"
            @balance="record.account.balance = Math.round((arguments[0] + school.account.balance) * 100) / 100"
            :profile="record"
        )
</template>

<script>
    /*eslint-disable*/
    import {mapState} from 'vuex';
    import usersListMixin from "../../../../utils/user/usersListMixin"
    import TransitionExpand from '../../../../elements/TransitionExpand.vue'
    const AccountBalanceModal = () => import("../../../../modals/AccountBalanceModal.vue");
    import SmallUserPreview from '../../../profiles/default-elements/SmallUserPreview.vue'
    import Transaction from './Transaction.vue'
    import Dropdown from '../../../../elements/Dropdown.vue'

    export default {
        mixins: [usersListMixin],
        props: {
            record: Object,
            openSchoolId: Number,
        },
        components: {
            Dropdown,
            Transaction,
            SmallUserPreview,
            TransitionExpand,
            AccountBalanceModal
        },
        data () {
            return {
                isLogsOpen: false,
                openedGrades: [],
                showBalanceModal: false,
            }
        },
        methods: {
            amountString (amount, isBalance = false) {
                const formatter = new Intl.NumberFormat('ru-RU', {
                    style: 'currency',
                    currency: 'RUB',
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 2,
                });
                return formatter.format(isBalance ? amount : Math.abs(amount));
            },
            sortTransactions (firstValue, secondValue) {
                if (!Array.isArray(firstValue) && !Array.isArray(secondValue)) {
                    return Date.parse(secondValue.createdAt) - Date.parse(firstValue.createdAt);
                }
                if (Array.isArray(firstValue) && !Array.isArray(secondValue)) {
                    return Date.parse(secondValue.createdAt) - Date.parse(firstValue[0].createdAt);
                }
                if (!Array.isArray(firstValue) && Array.isArray(secondValue)) {
                    return Date.parse(secondValue[0].createdAt) - Date.parse(firstValue.createdAt);
                }
                if (Array.isArray(firstValue) && Array.isArray(secondValue)) {
                    return Date.parse(secondValue[0].createdAt) - Date.parse(firstValue[0].createdAt);
                }
                return 0;
            },
            amountOfStudents (grade) {
                return grade.students.filter(student => student.status === 'active').length + ' '
                  + this.$i18n.tc('list.list_grade_studentDeclination', grade.students.filter(student => student.status === 'active').length);
            },
            handleClickOnGrade (index) {
                if (this.openedGrades.includes(index)) {
                    this.openedGrades.splice(this.openedGrades.indexOf(index), 1);
                } else {
                    this.openedGrades.push(index);
                }
            },
            isGradeOpened (index) {
                return this.openedGrades.includes(index);
            },
            isProfit (amount, transaction = null) {
                if (this.user.isSuperadmin) {
                    return amount < 0 || (transaction && transaction.operation === 'payment');
                } else {
                    return amount > 0;
                }
            },
            findGrade (gradeId) {
                return this.record.grades.find(grade => grade.id === gradeId);
            },
            formatDate (raw) {
                if (!raw) return '';
                const parts = raw.split(':'); // "2025:12:07"
                if (parts.length !== 3) return raw;
                const [year, month, day] = parts;
                // подгони формат под свой (у тебя в моках было '11/1/25')
                return `${day}/${month}/${year.slice(-2)}`; // "07/12/25"
            },
        },
        computed: {
            ...mapState({
                user: state => state.auth.user
            }),
            billingRows () {
                    if (!this.record) {
                        return [];
                    }

                    const school = this.record.data || this.record;

                    if (!school.transactions || !Array.isArray(school.transactions)) {
                        return [];
                    }

                    return [...school.transactions]
                    .sort((a, b) => {
                        return b.id - a.id;
                    }).map(item => ({
                        date: this.formatDate(item.day),
                        time: item.time,
                        user: item.author,
                        event: item.action,
                        subjectType: item.subject,
                        name: item.subjectName,
                        comment: item.comment,
                        school: item.schoolName,
                        tariff: item.currentTariffId,
                        amount: item.operationSum,
                        balance: item.balance,
                        studentSlots: item.studentSlots,
                        teacherSlots: item.teacherSlots,
                    }));
            },
            getTransactionsGroups () {
                return this.record.transactions.reduce((result, transaction) => {
                    if (transaction.gradeId) {
                        let tempArray = result
                            .filter(value => value.gradeId === transaction.gradeId)
                            .sort(this.sortTransactions);
                        result = result.filter(value => (value.gradeId !== transaction.gradeId) || Array.isArray(value));
                        tempArray.length && result.push(tempArray);
                        return result;
                    }
                    return result;
                }, this.record.transactions).sort(this.sortTransactions);
            },
            selectorSize () {
                const windowWidth = window.innerWidth;
                return windowWidth >= 1200 ? 'xx-large' : 'x-large';
            }
        }
    }
</script>

<style lang="scss" scoped>
    .indent-item {
        padding: 0 8px;
        @include media($md) {
            padding: 0 16px;
        }
    }

    .indent-item .indent-item {
        padding: 0 0 0 8px;
        @include media($md) {
            padding: 0 0 0 16px;
        }
    }

    .item-preview {
        margin: 8px 0;
        padding: 16px;
    }

    .item-preview--narrow {
        margin: 8px 0;
        padding: 12px 16px;
    }

    .school-preview, .grade-preview {
        background-color: $x-color-white;
        border: 1px solid $x-color-gray-5;
        border-radius: $border-radius-8;
        margin: 8px 0;
        overflow-x: hidden;
    }

    .school-preview--redBorder {
        border-color: $hsl-color-red-62;
    }

    .school-preview--redHover {
        cursor: pointer;
        &:hover {
            background-color: rgba($hsl-color-red-62, .1);
        }
    }

    .school-preview--greenHover {
        cursor: pointer;
        &:hover {
            background-color: rgba($hsl-color-green-58, .1);
        }
    }

    .grade-preview {
        cursor: pointer;
        position: sticky;
        top: 10px;
        z-index: 3;
    }

    .item-preview__column {
        display: flex;
        flex-direction: column;
        justify-content: center;
        padding: 0;
        margin-bottom: 8px;
        @include media($xlg) {
            margin-bottom: 0;
        }
    }

    .item-preview__column:last-child {
        margin-bottom: 0;
    }

    .item-preview__column:first-child {
        margin-bottom: 16px;
    }

    .item-preview__column_hide-name {
        @include media($sm) {
            display: none;
        }
    }

    .school-preview__name {
        margin-bottom: 16px;
        display: flex;
        align-items: center;
    }

    .school-preview__avatar {
        width: 50px;
        height: 50px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: $border-radius-circle;
        background-color: #F3F8EF;
    }

    .school-preview__icon {
        color: $hsl-color-green-58;
    }

    .school-preview__icon_orange {
        color: $x-color-orange;
    }

    .school-preview__icon_blue {
        color: $hsl-color-blue-56;
    }

    .school-preview__items {
        display: flex;
        margin: -4px 0;
    }

    .school-preview__items_columned {
        flex-direction: column;
    }

    .school-preview__item {
        display: flex;
        align-items: center;

        font-size: 13px;
        line-height: 16px;

        padding: 4px;
    }

    .preview__text {
        align-self: center;
        margin-left: 8px;
    }

    .preview__text_bold {
        font-weight: 500;
    }

    .preview__text_large {
        margin-left: 16px;
    }

    .school-preview__info {
        margin: -4px 0;
        @include media($md) {
            margin: -8px 0;
        }
    }

    .info__column {
        padding: 4px 0;
        @include media($md) {
            padding: 8px 0;
        }
    }

    .preview__text {
        margin-left: 8px;
    }

    .preview__text_large {
        margin-left: 16px;
    }

    .school-preview__link {
        display: inline-flex;
        color: $hsl-color-blue-56;
        text-decoration: none;
        &:hover {
            color: $hsl-color-blue-56;
            text-decoration: none;
        }
    }

    .school-preview__link_large {
        font-size: 16px;
        line-height: 20px;
        @include media($lg) {
            font-size: 18px;
        }
    }

    .dropdown__links {
        padding: 7px 14px;
        text-align: left;
        font-size: 16px;
        line-height: 26px;
        cursor: pointer;
    }

    .dropdown__link {
        padding-bottom: 7px;
        a {
            color: $hsl-color-blue-56;
            text-decoration: underline;
            &:hover {
                color: $hsl-color-blue-56;
                text-decoration: none;
            }
        }
    }

    .indent-item--billing {
        padding-left: 0;
        padding-right: 0;
    }

    .billing-table-wrapper {
        display: block;

        box-sizing: border-box;
        width: 100%;
        max-width: 100%;

        padding: 10px;

        overflow-x: auto;
        overflow-y: auto;

        -webkit-overflow-scrolling: touch;

        background: #fff;
        border-radius: 8px;
        box-shadow: 0 1px 3px rgba(15, 23, 42, 0.08);

        max-height: 60vh;
    }

    .billing-table {
        width: 100%;
        border-collapse: collapse;
        font-size: 13px;
        table-layout: auto;

        th,
        td {
            border: 1px solid #e2e8f0;
            padding: 8px 10px;
            vertical-align: middle;
        }

        th {
            background-color: #f3f4f6;
            font-weight: 600;
            color: #111827;
            text-align: left;
            white-space: nowrap;

            position: sticky;
            top: 0;
            z-index: 1;
        }

        td {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }

        td:nth-child(10),
        td:nth-child(11),
        td:nth-child(12),
        td:nth-child(13) {
            text-align: right;
        }

        tbody tr:nth-child(even) {
            background-color: #fafafa;
        }

        tbody tr:hover {
            background-color: #eef2ff;
        }
    }


</style>
